import { render, staticRenderFns } from "./ribbonDropMenu.vue?vue&type=template&id=8f3b5cdc"
import script from "./ribbonDropMenu.vue?vue&type=script&lang=js"
export * from "./ribbonDropMenu.vue?vue&type=script&lang=js"
import style0 from "./ribbonDropMenu.vue?vue&type=style&index=0&id=8f3b5cdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports